import { render } from "./UserNotificationsMatrix.vue?vue&type=template&id=43b74fce"
import script from "./UserNotificationsMatrix.vue?vue&type=script&lang=js"
export * from "./UserNotificationsMatrix.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./UserNotificationsMatrix.vue?vue&type=style&index=0&id=43b74fce&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__